export default __webpack_public_path__ + "static/media/DSCN1656.01cc2e39.JPG";